import { registerBlockType } from '@wordpress/blocks';
import { useBlockProps, InnerBlocks } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

registerBlockType('garden/services-grid', {
    apiVersion: 3,
    title: __('Siatka usług', 'garden'),
    icon: 'palmtree',
    category: 'garden',
    supports: {
        anchor: true
    },
    attributes: {
        columns: {
            type: 'number',
            default: 3
        }
    },
    edit: ({ attributes, setAttributes }) => {
        const blockProps = useBlockProps({
            className: 'services-grid'
        });

        const ALLOWED_BLOCKS = ['garden/service-card'];
        const TEMPLATE = [
            ['garden/service-card'],
            ['garden/service-card'],
            ['garden/service-card']
        ];

        return (
            <div {...blockProps}>
                <div className="services-grid-container">
                    <InnerBlocks
                        allowedBlocks={ALLOWED_BLOCKS}
                        // template={TEMPLATE}
                        orientation="horizontal"
                    />
                </div>
            </div>
        );
    },
    save: ({ attributes }) => {
        const blockProps = useBlockProps.save({
            className: 'wp-block services-grid'
        });

        return (
            <div {...blockProps}>
                <div className="services-grid-container">
                    <InnerBlocks.Content />
                </div>
            </div>
        );
    }
}); 
